"use client";

import { useState } from "react";
import { Col, Container, Form, Row } from "react-bootstrap";
import { DELEGATION_ABI } from "@/abis/abis";
import { DELEGATION_CONTRACT, NEVER_DATE } from "@/constants/constants";
import { isValidEthAddress } from "@/helpers/Helpers";
import type { DelegationCollection } from "./delegation-constants";
import { SUB_DELEGATION_USE_CASE } from "./delegation-constants";
import { getGasError } from "./delegation-shared";
import { DelegationAddressDisabledInput, DelegationCloseButton, DelegationFormCollectionFormGroup, DelegationFormDelegateAddressFormGroup, DelegationFormLabel, DelegationFormOriginalDelegatorFormGroup, DelegationSubmitGroups } from "./DelegationFormParts";
interface Props {
  address: string;
  subdelegation?: {
    originalDelegator: string;
    collection: DelegationCollection;
  } | undefined;
  ens: string | null | undefined;
  onHide(): any;
  onSetToast(toast: any): any;
}
export default function NewSubDelegationComponent(props: Readonly<Props>) {
  const [newDelegationCollection, setNewDelegationCollection] = useState<string>("0");
  const [newDelegationToAddress, setNewDelegationToAddress] = useState("");
  const [gasError, setGasError] = useState<string>();
  const contractWriteDelegationConfigParams = props.subdelegation ? {
    address: DELEGATION_CONTRACT.contract,
    abi: DELEGATION_ABI,
    chainId: DELEGATION_CONTRACT.chain_id,
    args: [props.subdelegation.originalDelegator, newDelegationCollection, newDelegationToAddress, NEVER_DATE, SUB_DELEGATION_USE_CASE.use_case, true, 0],
    functionName: validate().length === 0 ? "registerDelegationAddressUsingSubDelegation" : undefined,
    onSettled(data: any, error: any) {
      if (data) {
        setGasError(undefined);
      }
      if (error) {
        setGasError(getGasError(error));
      }
    }
  } : {
    address: DELEGATION_CONTRACT.contract,
    abi: DELEGATION_ABI,
    chainId: DELEGATION_CONTRACT.chain_id,
    args: [newDelegationCollection, newDelegationToAddress, NEVER_DATE, SUB_DELEGATION_USE_CASE.use_case, true, 0],
    functionName: validate().length === 0 ? "registerDelegationAddress" : undefined,
    onSettled(data_0: any, error_0: any) {
      if (data_0) {
        setGasError(undefined);
      }
      if (error_0) {
        setGasError(getGasError(error_0));
      }
    }
  };
  function validate() {
    const newErrors: string[] = [];
    if (!newDelegationCollection || newDelegationCollection === "0") {
      newErrors.push("Missing or invalid Collection");
    }
    if (!newDelegationToAddress || !isValidEthAddress(newDelegationToAddress)) {
      newErrors.push("Missing or invalid Address");
    } else if (props.subdelegation && newDelegationToAddress.toUpperCase() == props.subdelegation.originalDelegator.toUpperCase() || !props.subdelegation && newDelegationToAddress.toUpperCase() === props.address.toUpperCase()) {
      newErrors.push("Invalid Address - cannot delegate to your own wallet");
    }
    return newErrors;
  }
  return <Container>
      <Row>
        <Col xs={10} className="pt-3 pb-1">
          <h4>Register Delegation Manager (Sub-Delegation)</h4>
        </Col>
        <Col xs={2} className="pt-3 pb-1 d-flex align-items-center justify-content-end">
          <DelegationCloseButton onHide={props.onHide} title="Delegation Manager" />
        </Col>
      </Row>
      <Row className="pt-4">
        <Col>
          <Form>
            {props.subdelegation && <DelegationFormOriginalDelegatorFormGroup subdelegation={props.subdelegation} />}
            <Form.Group as={Row} className="pb-4">
              <DelegationFormLabel title={props.subdelegation ? `Delegator` : `Delegation Manager`} tooltip={`Address ${props.subdelegation ? `executing` : `registering`} the sub-delegation`} />
              <Col sm={9}>
                <DelegationAddressDisabledInput address={props.address} ens={props.ens} />
              </Col>
            </Form.Group>
            <DelegationFormCollectionFormGroup collection={newDelegationCollection} setCollection={setNewDelegationCollection} subdelegation={props.subdelegation} />
            <DelegationFormDelegateAddressFormGroup setAddress={setNewDelegationToAddress} title="Delegate Manager" tooltip="Delegation Manager Address" />
            <DelegationSubmitGroups title={"Registering Delegation Manager"} writeParams={contractWriteDelegationConfigParams} showCancel={true} gasError={gasError} validate={validate} onHide={props.onHide} onSetToast={props.onSetToast} />
          </Form>
        </Col>
      </Row>
    </Container>;
}